var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZigzagline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 54,
    viewBox: "0 0 319 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.231 37.5466L298.993 20.5133C290.741 5.34201 271.902 5.34201 263.676 20.5133L256.669 33.4257C248.417 48.5969 229.578 48.5969 221.352 33.4257L214.346 20.5133C206.094 5.34201 187.254 5.34201 179.028 20.5133L172.022 33.4257C163.77 48.5969 144.931 48.5969 136.705 33.4257L129.698 20.5133C121.446 5.34201 102.607 5.34201 94.3809 20.5133L87.3746 33.4257C79.1226 48.5969 60.2833 48.5969 52.0573 33.4257L45.0509 20.5133C36.799 5.34201 17.9596 5.34201 9.73362 20.5133L-0.127197 38.6456",
    stroke: "#FFC943",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZigzagline);
export default __webpack_public_path__ + "static/media/zigzagline.d53cccefabd3bd3dc2207e89f5aedb19.svg";
export { ForwardRef as ReactComponent };